export default [
    { path: '/404', component: () => import('@/views/404') },
    { path: '*', redirect: '/404' }
  ]


// WEBPACK FOOTER //
// ./src/router/common.js